export function parse(url) {
  const baseUrl =
    typeof window === "undefined" ? "http://localhost" : window.location.href;
  const parsedUrl = new URL(url, baseUrl);

  return {
    query: parsedUrl.search.startsWith("?")
      ? parsedUrl.search.slice(1)
      : parsedUrl.search,
  };
}
